import React from 'react';
import webapi from '../../../api/webapi';
import TagResultList from './TagResultList';
import Loading from '../modal/Loading';
import EmptyDiv from '../Footer/EmptyDIV';
import '../../css/react-tabs2.css';

class TagsBox extends React.Component {
    state = { LoadingShow : false }
    state = { filter : "" }
    state = { filterTitle : "" }
    state = { results : "" }
    

    constructor(props) {
        super(props);
    
        this.state = { books: [] };
        this.state = { chapters: [] };
        this.state = { SelectedBookGroup: '' };
        this.state = { SelectedBook: '' };
        this.state = { SelectedChapter: '' };
        this.state = { SelectedWordCategory: '' };
    }

    componentDidMount() {
        this.setState({LoadingShow:true})
        this.setState({ SelectedBook: '' });
        this.setState({ SelectedChapter: '' });

        this.GetBookGroups();
        this.GetWordCategory();

        this.setState({LoadingShow:false})
    };

    // constructor(props) {
    //     super(props);
           
    //     this.state = { books: [] };
    //     this.state = { chapters: [] };
    //     this.state = { SelectedBook: '' };
    //     this.state = { SelectedChapter: '' };
    //     this.state = { SelectedWordCategory: '' };
    //     //alert("Cons:"+this.state.SelectedBook);
    // }

    // async componentDidMount() {
    //     this.setState({LoadingShow:true})
    //     await webapi.get('surf/allbooks').then(response => {
    //         this.setState({ books: response.data});
    //       })

    //     await webapi.get('tags/allwordcategorys').then(response => {
    //         this.setState({ wordcategory: response.data});
    //      //console.log(response.data);
    //     })

    //     this.setState({ SelectedBook: 'All' });
    //     this.setState({ SelectedChapter: 'All' });
    //     this.setState({LoadingShow : false});
    //     this.setState({LoadingShow:false})
    //     //alert("componentDidMount:"+this.state.SelectedBook);
    // };

    // GetBookGroups = async () =>{
    //     await webapi.get('surf/allbookgroups')
    //         .then(response => {
    //             this.setState({ BookGroups: response.data},() => {} );
    //         })
    //     if (this.state.BookGroups!==undefined)
    //     {
    //         this.setState({ SelectedBookGroup : this.state.BookGroups[0].Code},() => {} );
    //         this.GetBooks(this.state.BookGroups[0].Code)
    //     }
    //     else
    //     {
    //         this.setState({SelectedBook : ''})
    //         this.setState({SelectedChapter : ''})
    //     }
    // }

    // GetBooks = async BookGroupCode =>{
    //     this.setState({LoadingShow:true})
    //     await webapi.get('surf/bookgroupsbook/'+BookGroupCode)
    //         .then(response => {
    //             this.setState({ books: response.data });
    //         })
    //    if (this.state.books!==undefined)
    //    {
    //        this.setState({ SelectedBook : this.state.books[0].Code },() => {} )
    //        this.GetChapters(this.state.books[0].Code)
    //     }
    //     else
    //     {
    //         this.setState({SelectedBook : ''})
    //         this.setState({SelectedChapter : ''})
    //     }                
    // }

    // GetChapters = async BookCode =>{
    //     this.setState({LoadingShow:true})
    //     await webapi.get('surf/bookschapter/'+ BookCode)
    //         .then(response => {
    //             this.setState({ chapters: response.data });
    //         })
    //    if (this.state.chapters!==undefined)
    //    {
    //        this.setState({ SelectedChapter : this.state.chapters[0].Code })
    //    }
    //    this.setState({LoadingShow:false})        
    // }

    GetBookGroups = async () =>{
        await webapi.get('surf/allbookgroups/'+this.props.Lang)
            .then(response => {
                this.setState({ BookGroups: response.data},() => {} );
            })
        if (this.state.BookGroups!==undefined)
        {
            //if (this.state.BookGroups.length===1)
            //{
                this.setState({ SelectedBookGroup : this.state.BookGroups[0].Code},() => {} );
                this.GetBooks(this.state.BookGroups[0].Code);
            //}
            // else
            // {
            //     this.setState({ SelectedBookGroup : 'All' });
            //     this.GetBooks('All');
            // }
        }
        else
        {
            this.setState({SelectedBook : ''})
            this.setState({SelectedChapter : ''})
        }
    }

    GetBooks = async BookGroupCode =>{
        this.setState({LoadingShow:true})
        await webapi.get('surf/bookgroupsbook/'+BookGroupCode+'/'+this.props.Lang)
            .then(response => {
                this.setState({ books: response.data });
            })
       
        if (this.state.books!==undefined)
        {
            if (this.state.books.length===1)
            {
                this.setState({ SelectedBook : this.state.books[0].Code },() => {} )
                this.GetChapters(this.state.books[0].Code)
            }
            else
            {
                this.setState({ SelectedBook : 'All' });
                this.GetChapters('All');
            }

        }
        else
        {
            this.setState({SelectedBook : ''})
            this.setState({SelectedChapter : ''})
        }                
    }

    GetChapters = async BookCode =>{
        this.setState({LoadingShow:true})
        await webapi.get('surf/bookschapter/'+ BookCode+'/'+this.props.Lang)
            .then(response => {
                this.setState({ chapters: response.data });
            })
        //if ((this.state.chapters)&&(this.state.chapters!==undefined)&&(this.state.chapters.length>0))
        if (this.state.chapters!==undefined)
        {
            if (this.state.chapters.length===1)
            {
                this.setState({ SelectedChapter : this.state.chapters[0].Code })
            }
            else
            {
                this.setState({ SelectedChapter : 'All' });
            }
            
       }
       this.setState({LoadingShow:false})        
    }

    GetWordCategory = async () => {
        this.setState({LoadingShow:true})
        await webapi.get('tags/allwordcategorys/'+this.props.Lang)
            .then(response => {
                this.setState({ wordcategory: response.data});
            })
        if (this.state.wordcategory!==undefined)
        {
            this.setState({ SelectedWordCategory : this.state.wordcategory[0].Code })
        }
        this.setState({LoadingShow:false}) 

    }

    // onChangeBookSelect = async event => {
    //     this.setState({LoadingShow:true})
    //     //console.log("bookcode", event.target.value)
    //     // this.setState({ SelectedBook: event.target.value});
    //     // await webapi.get('surf/bookschapter/'+event.target.value).then(response => {
    //     //      this.setState({ chapters: response.data});
    //     // })
    //     // if (this.state.chapters.length>1)
    //     //     {
    //     //         this.setState({ SelectedChapter :"All"})
    //     //         //console.log("r1");
    //     //     }
    //     // else    if (this.state.chapters.length===1)
    //     //             {
    //     //                 //console.log("r2");
    //     //                 this.setState({ SelectedChapter :this.state.chapters[0].Code})
    //     //             }
    //     //         else
    //     //             {
    //     //                 this.setState({ SelectedChapter :"All"}) 
    //     //             }
    //     // this.setState({LoadingShow:false})
    //     this.GetChapters();
    // };

    // onChangeChapterSelect = event => {
    //     //console.log("chaptercode=>:", event.target.value)
    //     this.setState({ SelectedChapter : event.target.value});
    //     // await webapi.get('surf/chaptersparagraph/'+event.target.value).then(response => {
    //     //       this.setState({ paragraphs: response.data});
    //     //       this.setState({ paragraphsequences: response.data});
    //     //       //console.log(response.data);
    //     //  })
    //     //alert(this.state.SelectedChapter)
    // };

    onChangeBookGroupSelect = async event => {
        this.setState({LoadingShow:true})
        this.setState({ results: '' });
        this.setState({ SelectedBookGroup: event.target.value});
        
        this.GetBooks(event.target.value);
    };

    onChangeBookSelect = async event => {
        this.setState({LoadingShow:true})
        this.setState({ results: '' });
        this.setState({ SelectedBook: event.target.value},()=>{});
        
        this.GetChapters( event.target.value );
    };

    onChangeChapterSelect = async event => {
        this.setState({ results: '' });
        this.setState({ SelectedChapter:event.target.value }, () => {})
    };

    

    onChangeWordCategorySelect = async event => {
        //console.log("bookcode", event.target.value)
        this.setState({LoadingShow:true})
        this.setState({ results: '' });
        this.setState({ wordpropertytype: ''});
        this.setState({ SelectedWordCategory: event.target.value});
        var x;
        await webapi.get('tags/wordpropertytype/'+event.target.value+'/'+this.props.Lang)
            .then(response => {
                this.setState({ wordpropertytype: response.data},()=>{

                    if ((this.state.wordpropertytype)&&(this.state.wordpropertytype.length>0))
                    {
                        this.setState({filterTitle:(this.props.pageData.length!==0 && this.props.pageData[0].F29902!== undefined?this.props.pageData[0].F29902:29902)/*"همه"*/});
                        this.setState({filter:"All"});
                        x = document.getElementsByClassName("content");
                        x[0].style.display = "block";
                    }
                    else
                    {
                        this.setState({filterTitle:""});
                        this.setState({filter:""});
                        x = document.getElementsByClassName("content");
                        x[0].style.display = "None";
                    }

                });
                //console.log(response.data);
            })

        x = document.getElementsByClassName("collapsible");
        x[0].style.display = "None";
        this.setState({LoadingShow:false})
    };

    onChangeWordPropertySelect = event => {
        //console.log("Itemcode", event.target.value)
        this.setState({ results: '' });
        var filter="All";
        var filterTitle=(this.props.pageData.length!==0 && this.props.pageData[0].F29902!== undefined?this.props.pageData[0].F29902:29902)/*"همه"*/;
        var coll = document.getElementsByClassName("SelectItems");
        var i;
        

        for (i = 0; i < coll.length; i++) {
            if(coll[i].value!=="All")
            {
                if (filter==="All")
                {
                    filter=coll[i].value;
                    filterTitle=coll[i][coll[i].selectedIndex].text;
                }
                else
                {
                    filter=filter+","+coll[i].value;                    
                    filterTitle=filterTitle+"، "+coll[i][coll[i].selectedIndex].text;
                }
                
            }
        }
        if (filter==="")
            filter="All";
        if (filterTitle==="")
            filterTitle=(this.props.pageData.length!==0 && this.props.pageData[0].F29902!== undefined?this.props.pageData[0].F29902:29902)/*"همه"*/;
        this.setState({filter:filter});
        this.setState({filterTitle:filterTitle});
        //console.log("filter",filter);
        //console.log("filterTitle",filterTitle);
        //this.setState({ SelectedBook: event.target.value});
        //await webapi.get('tags/wordpropertytype/'+filter).then(response => {
        //      this.setState({ wordpropertytype: response.data});
              //console.log(response.data);
         //})
    };

    onSearchButtonClick = event => {
        event.preventDefault();
        // console.log(this.state.filter);
        // console.log(this.state.filterTitle);
        var x = document.getElementsByClassName("content");
        x[0].style.display = "None";

        // console.log((this.state.filter));
        // console.log((this.state.filter===undefined));
        // console.log((this.state.filter===""));

        if (((this.state.filter===undefined)||(this.state.filter==="")))
        {
            //console.log(1);
            x = document.getElementsByClassName("collapsible");
            x[0].style.display = "None";
        }
        else
        {
            //console.log(2);
            x = document.getElementsByClassName("collapsible");
            x[0].style.display = "block";
            this.Search(this.state.SelectedWordCategory+"/"+this.state.filter+"/"+this.state.SelectedBookGroup+"/"+this.state.SelectedBook+"/"+this.state.SelectedChapter);
        }
    };

    Search = async filter => {
        //console.log(filter);
        this.setState({ results: ''});
        this.setState({LoadingShow : true})
        //tags/textproperty/{CategoryCode}/{TextProperty}/{Book}/{Chapter}
        await webapi.get('tags/textproperty/'+filter)
            .then(response => {
                //console.log(response.data);
                //console.log('tags/textproperty/'+filter);
                this.setState({ results: response.data});
                this.setState({LoadingShow : false})
            })
            .catch(error => {
                this.setState({LoadingShow : false})
                console.log(error);
            });

        // await webapi.get('tags/textproperty/'+filter, {
        //     onDownloadProgress: progressEvent => {
        //         const total = parseFloat(progressEvent.currentTarget.responseHeaders['content-length'])
        //         const current = progressEvent.currentTarget.response.length
            
        //         let percentCompleted = Math.floor(current / total * 100)
        //         console.log('completed: ', percentCompleted)
        //     }
        // })
        // .then(response => {
        //     console.log("All DONE: ", response.headers)
        //     this.setState({ results: response.data});
        //     //console.log(response.data);
        //     this.setState({LoadingShow : false})
        // })
    }


    onCollapsibleButtonClick = event => {
        var x = document.getElementsByClassName("content");
        
        if (x[0].style.display === "block") {
            x[0].style.display = "none";
            event.target.style.display="block";
        } else {
            x[0].style.display = "block";
            event.target.style.display="none";
        }
    };

    render() {
        return (
            [
                <div className="container-fluid" id="tags_main_content">
                    <div className="container">
                        <div id="search_param">
                            <Loading LoadingShow={this.state.LoadingShow} />
                            <form method="post" encType="multipart/form-data" action="">
                            <div className="select_param_1">
                                    <label>{this.props.pageData.length!==0 && this.props.pageData[0].F20301!== undefined?this.props.pageData[0].F20301:20301/*"نوع متن"*/}</label>
                                    <select className="form-control" id="search_book" name="search_book" onChange={this.onChangeBookGroupSelect}>
                                        {
                                        //<option value="-1" select="true">-</option>
                                        }
                                        {/* <option value={"All"}>همه</option> */}
                                        {   this.state.BookGroups != null 
                                            ?
                                            (   
                                                this.state.BookGroups.map((BookGroup) =>{
                                                    return  (
                                                        <option key={'BG'+BookGroup.Code} value={BookGroup.Code}>{BookGroup.Title}</option> 
                                                    )
                                                })
                                            )
                                            :
                                            <option key="-1">-</option>       
                                        }
                                    </select>
                                </div>
                                <div className="select_param_1">
                                    { 
                                        (this.state.SelectedBookGroup==="2")
                                        ?
                                        <label>{this.props.pageData.length!==0 && this.props.pageData[0].F20305!== undefined?this.props.pageData[0].F20305:20305/*نوع کتیبه*/}</label>
                                        :
                                        <label>{this.props.pageData.length!==0 && this.props.pageData[0].F20302!== undefined?this.props.pageData[0].F20302:20302/*نام متن*/}</label>
                                    }
                                    <select className="form-control" id="search_book" name="search_book" onChange={this.onChangeBookSelect}>
                                        {
                                        //<option value="-1" select="true">-</option>
                                        <option key='BAll' value={"All"}>
                                            {this.props.pageData.length!==0 && this.props.pageData[0].F29902!== undefined?this.props.pageData[0].F29902:29902/*"همه"*/}</option>
                                        }
                                        {   this.state.books != null 
                                            ?
                                            (   
                                                this.state.books.map((book) =>{
                                                    return  (
                                                        <option key={'B'+book.Code} value={book.Code}>{book.Title}</option> 
                                                    )
                                                })
                                            )
                                            :
                                            <option key="-1">-</option>       
                                        }
                                    </select>
                                </div>
                                <div className="select_param_1">
                                    { 
                                        (this.state.SelectedBookGroup==="2")
                                        ?
                                        <label>{this.props.pageData.length!==0 && this.props.pageData[0].F20306!== undefined?this.props.pageData[0].F20306:20306/*نام کتیبه*/}</label>
                                        :
                                        <label>{this.props.pageData.length!==0 && this.props.pageData[0].F20303!== undefined?this.props.pageData[0].F20303:20303/*شماره فصل*/}</label>
                                    }
                                    <select className="form-control" id="search_chapter" name="search_chapter" onChange={this.onChangeChapterSelect}>
                                        
                                        {
                                            //<option value="-1" select="true">-</option>
                                        }
                                            
                                        {   this.state.chapters != null 
                                            ?
                                            (   
                                                this.state.chapters.map((chapter,i) =>{
                                                    return  (
                                                        (this.state.chapters.length>1 && i===0)
                                                        ?
                                                        (
                                                            <>
                                                                <option key="All" value="All" select="true">
                                                                    {this.props.pageData.length!==0 && this.props.pageData[0].F29902!== undefined?this.props.pageData[0].F29902:29902/*"همه"*/}
                                                                </option>
                                                                <option key={chapter.Code} value={chapter.Code}>{chapter.Title}</option>
                                                            </>
                                                        )
                                                        :
                                                        (
                                                            (this.state.chapters.length===0 && i===0)
                                                            ?
                                                            (
                                                                <option key={-1} value={-1}>-1</option>
                                                            )
                                                            :
                                                            (
                                                                <option key={chapter.Code} value={chapter.Code}>{chapter.Title}</option>
                                                            )
                                                        )
                                                    )
                                                })
                                            )
                                            :
                                            <option key="-1">-</option>       
                                        }
                                    </select>
                                </div>
                                
                                <div className="select_param_1">
                                    <label>{this.props.pageData.length!==0 && this.props.pageData[0].F20304!== undefined?this.props.pageData[0].F20304:20304/*مقوله دستوری*/}</label>
                                    <select className="form-control" id="search_paragraph" name="search_paragraph" onChange={this.onChangeWordCategorySelect}>
                                    {/* <option value="-1" select="true">-</option> */}
                                        <option value={"None"}>-</option>
                                        {   this.state.wordcategory != null 
                                            ?
                                            (   this.state.wordcategory.map((wordcategory) =>{
                                                    return  (
                                                                <option key={wordcategory.Code} value={wordcategory.Code}>{wordcategory.Title}</option> 
                                                            )
                                                })
                                            )
                                            :
                                            <option key="-1">-</option>       
                                        }
                                    </select>
                                </div>
                                <button type="button" className="collapsible" onClick={this.onCollapsibleButtonClick}>{this.state.filterTitle}</button>
                                <div className="content search_params_2">
                                    {   
                                        ((this.state.wordpropertytype)&&(this.state.wordpropertytype != null)&&(this.state.wordpropertytype.length>0))
                                        ?
                                        (
                                            this.state.wordpropertytype.map((wordpropertytype) =>{
                                                return  (
                                                            <div className="outer100">
                                                                <div className="inner-title25">
                                                                    {wordpropertytype.Title}
                                                                </div>
                                                                <div className="inner-content75">                                        
                                                                    <select onChange={this.onChangeWordPropertySelect} id={wordpropertytype.Code} className="SelectItems">
                                                                        <option value={"All"}>
                                                                            {this.props.pageData.length!==0 && this.props.pageData[0].F29902!== undefined?this.props.pageData[0].F29902:29902/*"همه"*/}
                                                                        </option>
                                                                        {   wordpropertytype.WordPropertys != null 
                                                                            ?
                                                                            (   wordpropertytype.WordPropertys.map((WordProperty) =>{
                                                                                    return  (
                                                                                                <option value={WordProperty.Code}>{WordProperty.Title}</option> 
                                                                                            )
                                                                                })
                                                                            )
                                                                            :
                                                                            <option key="-1">-</option>       
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        )
                                            })
                                        )
                                        :
                                        null
                                    }
                                    
                                </div>
                                <div className="fullwidth_div">
                                    <input type="submit" className="submit_button" value={this.props.pageData.length!==0 && this.props.pageData[0].F29901!== undefined?this.props.pageData[0].F29901:29901/*"جستجو"*/} onClick={this.onSearchButtonClick} />
                                    </div>
                            </form>
                        </div>
                    </div>
                </div>
                ,
                <br />
                ,
                (this.state.results && this.state.results.length>0)
                ?
                <div style={{ width:'80%',margin:'auto',paddingBottom:'10%'}}>
                    <TagResultList  results={this.state.results}
                                    pageData={this.props.pageData}
                    />
                </div>
                :
                <EmptyDiv />
                ,
                <Loading LoadingShow={this.state.LoadingShow} />
            ]
        )
    }
}

export default TagsBox;